import { atom } from "recoil"

export const isAuthenticated = atom({
  key: "is_authenticated",
  default: !!sessionStorage.getItem("token"),
})
